import React, { useEffect, useMemo, useState } from 'react';
import { Col, Container, Input, InputGroup, Row, Table } from 'reactstrap';
import { FulfilledSummaryModal } from '../../../Components/CustomModal';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';

import excelImage from '../../../images/tableExcel.png';
import actionIcon from '../../../images/actionIncon.png';

import './index.css';
import {
  CNFUpdateInvoice,
  exportCNFFulfilledOrders,
  getCNFFulfilledOrders,
  getCNFTerritoryManagers,
} from '../../../constants/apiCalls';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import _ from 'lodash';
import moment from 'moment';
import UpdateDispatchDetails from '../../../Components/CustomModal/UpdateDispatchDetails/UpdateDispatchDetails';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

function FulfilledOrders() {
  const [isLoading, setIsLoading] = useState(false);
  const [fulfilledSummaryModal, setFulfilledSummaryModal] = useState(false);
  const [fulfilledSummaryData, setFulfilledSummaryData] = useState(null);

  const [data, setData] = useState([]);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [filterBy, setFilterBy] = useState('order_date');

  const [searchText, setSearchText] = useState('');

  const [bookOrderId, setBookOrderId] = useState('');
  const [updateDispatchModal, setUpdateDispatchModal] = useState(false);

  // Filters

  const [territoryList, setTerritoryList] = useState([]);
  const [territoryManagerList, setTerritoryManagerList] = useState([]);
  // const [territoryFilterList, setTerritoryFilterList] = useState([]);
  const [territoryId, setTerritoryId] = useState('');
  const [tmId, setTmId] = useState('');

  const filteredTerritory = useMemo(() => {
    if (tmId === 'all') {
      return territoryList;
    }

    if (tmId) {
      const finalList = territoryList.filter((t) => {
        const list = territoryManagerList
          .filter((tl) => tl.user_id.toString() === tmId)
          .map((o) => o.territory_id);
        return list.includes(t.territory_id);
      });
      return finalList;
    }
    return territoryList;
  }, [tmId, territoryList, territoryManagerList]);

  // Date Filter

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    getCNFTerritoryManagers((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setTerritoryList(data.territory);
        setTerritoryManagerList(data.territory_manager);

        setIsLoading(false);
      } else if (success === false || success === 'undefined') {
        setIsLoading(false);
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
      }
      setIsLoading(false);
    });
  }, []);

  const fetchData = () => {
    setIsLoading(true);

    const payload = { page, pagesize: pageSize };

    if (searchText) {
      payload.q = searchText.trim();
    }
    if (territoryId && territoryId !== 'all') {
      payload.territory_id = territoryId;
    }
    if (tmId && tmId !== 'all') {
      payload.user_id = tmId;
    }
    if (startDate) {
      payload.start_date = moment(startDate).format('MM-DD-YYYY');
    }
    if (endDate) {
      payload.end_date = moment(endDate).format('MM-DD-YYYY');
    }

    if (endDate || startDate) {
      payload.filter_by_date = filterBy;
    }
    getCNFFulfilledOrders((res) => {
      const { data, success, error } = res;

      if (success) {
        setIsLoading(false);
        setData(data);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
        setIsLoading(false);
      }
    }, payload);
  };

  const exportImage = () => {
    setIsLoading(true);

    const payload = { page, pagesize: pageSize };

    if (searchText) {
      payload.q = searchText.trim();
    }
    if (territoryId && territoryId !== 'all') {
      payload.territory_id = territoryId;
    }
    if (tmId && tmId !== 'all') {
      payload.user_id = tmId;
    }
    if (startDate) {
      payload.start_date = moment(startDate).format('MM-DD-YYYY');
    }
    if (endDate) {
      payload.end_date = moment(endDate).format('MM-DD-YYYY');
    }

    if (endDate || startDate) {
      payload.filter_by_date = filterBy;
    }

    exportCNFFulfilledOrders((res) => {
      const { data, success, error } = res;

      if (success) {
        setIsLoading(false);

        window.open(data.file, '_blank');
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
        setIsLoading(false);
      }
    }, payload);
  };

  const debouncedSearch = _.debounce(() => fetchData(), 300);

  useEffect(() => {
    if (!territoryId) return;
    fetchData();
  }, [territoryId]);

  useEffect(() => {
    if (!tmId) return;
    fetchData();
  }, [tmId]);

  useEffect(() => {
    fetchData();
  }, [startDate]);

  useEffect(() => {
    fetchData();
  }, [endDate]);

  useEffect(() => {
    if (!startDate || !endDate) return;
    fetchData();
  }, [filterBy]);

  useEffect(() => {
    if (!searchText) return;
    debouncedSearch();
  }, [searchText]);

  useEffect(() => {
    fetchData();
  }, [page, pageSize]);

  const updateInvoiceData = (data) => {
    setIsLoading(true);
    CNFUpdateInvoice(
      (res) => {
        const { success, error } = res;

        if (success) {
          setIsLoading(false);

          setBookOrderId('');
          setUpdateDispatchModal(false);
          fetchData();
        } else if (success === false || success === 'undefined') {
          setIsLoading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },

      {
        order_id: bookOrderId,
        transporter_name: data.transporter_name || '',
        lr_dispatch_details: data.lr_dispatch_details || '',
      },
    ).finally(() => {
      setIsLoading(false);
    });
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id="cnf-fulfilled-orders">
              {isLoading && <CustomSpinner />}
              <Container fluid>
                <Row>
                  <Col xs={12}>
                    <div className="pageheader">
                      <DashBoardTitle dashBorardName="Fulfilled Orders" />
                    </div>
                  </Col>
                </Row>
                <div className="filterArea">
                  <Row>
                    <Col>
                      <div className="searchInput">
                        <Input
                          name="search"
                          autoComplete="off"
                          type="text"
                          placeholder={'Search by Code, Name or Order Number'}
                          id="search"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        <img
                          src={excelImage}
                          onClick={exportImage}
                          style={{ cursor: 'pointer' }}
                          className="excelImg"
                          alt="excel"
                        />
                      </div>
                      <Row className="filterContainer">
                        {/* Territory */}
                        <div className="filterDropdown">
                          <label htmlFor="territoryName">Territory Manager:</label>
                          <br />
                          <select
                            value={tmId}
                            onChange={(e) => setTmId(e.target.value)}
                            name="territoryManager"
                            id="territoryManager"
                          >
                            <option value="all">All</option>
                            {territoryManagerList.length > 0 &&
                              [
                                ...new Map(
                                  territoryManagerList.map((item) => [
                                    item['business_name'],
                                    item,
                                  ]),
                                ).values(),
                              ].map((elem, index) => {
                                const {
                                  id = null,
                                  user_id = null,
                                  business_name,
                                } = elem;
                                return (
                                  <option value={user_id || id} key={index}>
                                    {business_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        <div className="filterDropdown ">
                          <label htmlFor="tmName">Territory:</label>
                          <br />

                          <select
                            name="territory"
                            id="territory"
                            value={territoryId}
                            onChange={(e) => setTerritoryId(e.target.value)}
                          >
                            <option value="all" key="0-random">
                              All
                            </option>
                            {filteredTerritory.length > 0 &&
                              filteredTerritory.map((elem, index) => {
                                const { name, territory_id } = elem;
                                return (
                                  <option value={territory_id} key={index}>
                                    {name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>

                        <div className="filterDateBy">
                          <p>Date Filter For:</p>
                          <div onChange={(e) => setFilterBy(e.target.value)}>
                            <InputGroup>
                              <input
                                type="radio"
                                value="order_date"
                                name="filterBy"
                                defaultChecked
                                id="orderDate"
                              />
                              <label htmlFor="orderDate">Order Date</label>
                            </InputGroup>
                            <InputGroup>
                              <input
                                value="invoice_date"
                                type="radio"
                                name="filterBy"
                                id="invoiceDate"
                              />
                              <label htmlFor="invoiceDate">Invoice Date</label>
                            </InputGroup>
                          </div>
                        </div>
                        <div className="filterDate filterInput">
                          <label htmlFor="startDate">From Date:</label>
                          <br />
                          <input
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            type="date"
                            name="startDate"
                            id="startDate"
                          />
                        </div>
                        <div className="filterDate filterInput">
                          <label htmlFor="endDate">To Date:</label>
                          <br />
                          <input
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            type="date"
                            name="endDate"
                            id="endDate"
                          />
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </div>
                <div className="tableArea">
                  <Table bordered responsive>
                    <thead>
                      <tr>
                        <th>Order Date</th>
                        <th>Order Number</th>
                        <th>Invoice Date</th>
                        <th>Invoice Number</th>
                        <th>Status</th>
                        <th>Dealer Code</th>
                        <th>Dealership Name</th>
                        <th>Mobile No.</th>
                        <th>Territory</th>
                        <th>Dispatch Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((data, i) => {
                        return (
                          <tr>
                            <td>{moment(data.order_date).format('ll')}</td>
                            <td>
                              <span
                                className="orderNumber"
                                onClick={() => {
                                  setFulfilledSummaryModal(true);
                                  setFulfilledSummaryData(data);
                                }}
                              >
                                {data.order_number || '-'}
                              </span>
                            </td>
                            <td>
                              {data.invoice_date
                                ? moment(data.invoice_date).format('ll')
                                : '-'}
                            </td>
                            <td>{data.invoice_no || '-'}</td>
                            <td>{data.order_status || '-'}</td>
                            <td>{data.dealer_code || '-'}</td>
                            <td>{data.dealership_name || '-'}</td>
                            <td>{data.mobile_number || '-'}</td>
                            <td>{data.territory}</td>
                            <td>
                              {data.transporter_name ? (
                                <div>
                                  {data.transporter_name}{' '}
                                  <div className="transporterBlock">
                                    <img
                                      src={actionIcon}
                                      alt="actionImg"
                                      style={{ cursor: 'pointer' }}
                                      className="actionIconImg"
                                    />
                                    <div className="transporterTooltip commonTooltip">
                                      <div>
                                        <div>
                                          <strong>Transporter Name</strong>
                                        </div>
                                        <div>{data.transporter_name}</div>
                                      </div>
                                      <div style={{ marginTop: '10px' }}>
                                        <div>
                                          <strong>LR / Dispatch Details</strong>
                                        </div>
                                        <div>{data.lr_dispatch_details}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <span
                                  onClick={() => {
                                    setUpdateDispatchModal(true);
                                    setBookOrderId(data.order_number);
                                  }}
                                  style={{
                                    color: 'blue',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                  }}
                                >
                                  Add
                                </span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <div className="paginationArea">
                  <button
                    className="textButton textButton_blue"
                    onClick={() => {
                      if (page <= 1) {
                        return;
                      }

                      setPage((p) => p - 1);
                    }}
                  >
                    Previous
                  </button>
                  <div className="paginator">
                    <span>Page</span>
                    <input
                      min={1}
                      type="number"
                      defaultValue={1}
                      value={page}
                      onChange={(e) => setPage(e.target.value)}
                    />
                    <span>
                      of <strong>20</strong>
                    </span>
                    <select onChange={(e) => setPageSize(e.target.value)}>
                      <option value={10}>10 Rows</option>
                      <option value={20}>20 Rows</option>
                      <option value={30}>30 Rows</option>
                    </select>
                  </div>
                  <button
                    className="textButton textButton_blue"
                    onClick={() => {
                      setPage((p) => p + 1);
                    }}
                  >
                    Next
                  </button>
                </div>
              </Container>
              {fulfilledSummaryModal && (
                <FulfilledSummaryModal
                  isOpen={fulfilledSummaryModal}
                  orderData={fulfilledSummaryData}
                  toggle={() => {
                    setFulfilledSummaryModal(!fulfilledSummaryModal);
                    setFulfilledSummaryData(null);
                  }}
                />
              )}
              {updateDispatchModal && (
                <UpdateDispatchDetails
                  isOpen={updateDispatchModal}
                  bookOrderId={bookOrderId}
                  updateInvoice={updateInvoiceData}
                  toggle={() => {
                    setUpdateDispatchModal(!updateDispatchModal);
                    setBookOrderId('');
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FulfilledOrders;
